<div tp="Need to Save changes" [tpIsEnabled]="needSave === true">
  <button
    class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
    [ngClass]="{
      'cursor-default': needSave === true,
      'hover:bg-m200': needSave === false
    }"
    [disabled]="needSave === true"
    data-cy="folderOptionsMenuButton"
    #t1="tippy"
    [tp]="templateFolderOptions"
    [tpHideOnEscape]="true"
    tpVariation="menu"
    className="my-menu"
    (click)="clickMenu($event)"
  >
    <m-dots-vertical-icon></m-dots-vertical-icon>
  </button>
</div>

<ng-template #templateFolderOptions>
  <div class="border-s4 bg-m0 w-48 rounded-md border-2 shadow-xl">
    <button
      data-cy="folderOptionsNewFolderButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); newFolder(node, $event)"
      >New Folder</button
    >

    <button
      data-cy="folderOptionsNewFileButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); newFile(node, $event)"
      >New File</button
    >

    <button
      *ngIf="!(node.parent === null || node.parent.data.virtual)"
      data-cy="folderOptionsDeleteFolderButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); deleteFolder(node, $event)"
      >Delete Folder</button
    >

    <button
      *ngIf="!(node.parent === null || node.parent.data.virtual)"
      data-cy="folderOptionsRenameFolderButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); renameFolder(node, $event)"
      >Rename Folder</button
    >
  </div>
</ng-template>

<div *ngIf="nav$ | async"></div>
<div *ngIf="needSave$ | async"></div>
